import { useEffect } from 'react';
import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { ERROR_TOAST_DEFAULTS, SUCCESS_TOAST_DEFAULTS } from '@helpers';
import { useToast } from '@chakra-ui/react';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';
import { getSessionTokenV3 } from 'helpers/sessionContext';


export const useDelete = () => {
  const client = useClient({
    token: getSessionTokenV3() as string,
    url: process.env.REACT_APP_API_V3,
  });

  const toast = useToast();

  const { team } = useSession();

  const { t } = useTranslation();

  const teamUUID = team?.uuid as string;

  const mutation = useMutation(
    ['delete-contact', teamUUID],
    async (contact: string) => {
      await client.deleteContact(teamUUID, contact);

      const MESSAGE = t(translations.CONTACTS.DELETE_SUCCESS);

      toast({ ...SUCCESS_TOAST_DEFAULTS, title: MESSAGE });
    },
  );

  useEffect(() => {
    if (mutation.isError) {
      const error = mutation.error as AxiosError;
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);
      if (error?.response?.status === 403) {
        msg = t(translations.ERRORS.PERMISSIONS);
      }
      if (error?.response?.status === 409) {
        msg = t(translations.CONTACTS.STATUS_CODE_409);
      }
      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutation.isError]);

  return { ...mutation };
};
